import { render } from "./TrainingApplications.vue?vue&type=template&id=1a83c007&scoped=true"
import script from "./TrainingApplications.vue?vue&type=script&lang=js"
export * from "./TrainingApplications.vue?vue&type=script&lang=js"

import "./TrainingApplications.vue?vue&type=style&index=0&id=1a83c007&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a83c007"]])

export default __exports__